import React from 'react'

import classNames from 'classnames'

import { onEnter } from 'utils/accessibility'

import { TabButtonProps } from './boxPricesTabsModels'

import css from './BoxPricesTabs.css'

export const TabButton = ({ text, isActive, onClick }: TabButtonProps) => (
  <div
    tabIndex={0}
    role="button"
    className={classNames(css.tab, { [css.tabActive]: isActive })}
    onClick={onClick}
    onKeyPress={onEnter(onClick)}
  >
    {text}
  </div>
)
